var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { AttachedTrait } from '../../attachedtrait/AttachedTrait';
import { slotRegistry } from '../../../../registry/Registry';
import { runtime } from '../../../runtime/Runtime';
import { mergeIntoAspectsTemplate } from '../AttachedActionTrait';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { editable } from '../../../../utils/mobx/decorators/editable';
export class AttachedSlotTrait extends AttachedTrait {
    isEditSlotPopoverOpen = false;
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get slotReg() {
        return slotRegistry().registry_object[this.trait.value];
    }
    get aspectsTemplate() {
        const aspectsTemplate = super.aspectsTemplate;
        mergeIntoAspectsTemplate(this.reg.aspectsTemplate, aspectsTemplate);
        if (this.slotReg && this.slotReg.paramsFinal) {
            mergeIntoAspectsTemplate(this.slotReg.paramsFinal, aspectsTemplate);
        }
        return aspectsTemplate;
    }
    get context() {
        return super.context;
    }
    get slotFind() {
        return new runtime.solidPackages.Edit.classes.AttachedSlotFind(this);
    }
    get slotFill() {
        return new runtime.solidPackages.Edit.classes.AttachedSlotFill(this);
    }
    get slotEdit() {
        return new runtime.solidPackages.Edit.classes.AttachedSlotEdit(this);
    }
    get foundSlotMatches() {
        return this.slotReg.find(this.context);
    }
    get isSlotFilled() {
        return this.slotReg.verify(this.context, this.foundSlotMatches);
    }
}
__decorate([
    editable()
], AttachedSlotTrait.prototype, "isEditSlotPopoverOpen", void 0);
__decorate([
    memoize
], AttachedSlotTrait.prototype, "slotFind", null);
__decorate([
    memoize
], AttachedSlotTrait.prototype, "slotFill", null);
__decorate([
    memoize
], AttachedSlotTrait.prototype, "slotEdit", null);
__decorate([
    computed
], AttachedSlotTrait.prototype, "foundSlotMatches", null);
__decorate([
    computed
], AttachedSlotTrait.prototype, "isSlotFilled", null);
